import { subscribeOnInit } from './subscribe-on-init.func';
import { unsubscribeOnDestroy } from './unsubscribe-on-destroy.func';
export function Subscribe(observables) {
    return function (target) {
        subscribeOnInit(target, observables);
        unsubscribeOnDestroy(target);
    };
}
;
//# sourceMappingURL=ngx-reactive-decorator.subscribe.func.js.map